const dataSortMixin = {
    methods: {
      formatDate: function(date, format = 'default') {
        if (!date) {
          return ''
        }
  
        format = date.indexOf('/') > -1 ? 'invert' : format
  
        let characterSplit = format == 'default' ? '-' : '/'
        let characterConcat = format == 'default' ? '/' : '-'
  
              let dateHora = date.split(' ');
              let dateFormat = dateHora[0].split(characterSplit);
  
              return dateFormat[2] + characterConcat + dateFormat[1] + characterConcat + dateFormat[0];
        },
        dataSort: function ({ dados, ordenador, ordemAtual }) {
            if (ordenador == ordemAtual) {
                return {
                    ordem: ordemAtual,
                    dados: dados.reverse()                    
                }
            }

            return {
                ordem: ordenador,
                dados: dados.sort((p1, p2) => {
                    let value1 = ordenador == 'data_alteracao' ? this.formatDate(p1[ordenador], 'invert') : p1[ordenador]
                    let value2 = ordenador == 'data_alteracao' ? this.formatDate(p2[ordenador], 'invert') : p2[ordenador]

					if (value1 <= value2) return -1;
					if (value1 > value2) return 1;
					return 0;
				})
            }
        },
    }
}

export default dataSortMixin
